import React from 'react';
import { EtaQuantityOnOrder, Warehouse } from '../internal/common.types';
import Typography from '@mui/material/Typography';
import { useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import WarehouseETAExpectedShip from './internalETA/WarehouseETAExpectedShip';

type Props = {
  centralStock: number | false;
  etaEllipsis?: boolean | false;
  localStock: number | false;
  preOrderEtaStockDetails: any;
  reserveFlag?: boolean;
  tooltipsShow: boolean;
  warehouses?: Warehouse[];
};
export function WarehouseETAOutOfStock(props: Props) {
  const {
    centralStock,
    etaEllipsis,
    localStock,
    preOrderEtaStockDetails,
    reserveFlag,
    tooltipsShow,
  } = props;
  const translate = useTranslate();

  const getQuantityOnOrder = () => {
    if (
      preOrderEtaStockDetails !== null &&
      preOrderEtaStockDetails !== undefined &&
      preOrderEtaStockDetails?.length > 0
    ) {
      const quantityOnOrderArray: EtaQuantityOnOrder[] = [];
      preOrderEtaStockDetails?.forEach((warehouse: any, i: number) => {
        if (
          warehouse.stockType === 'ONORDER' &&
          warehouse.quantity !== undefined &&
          warehouse.quantity > 0
        ) {
          quantityOnOrderArray.push(warehouse);
        }
      });

      return quantityOnOrderArray.sort((a, b) =>
        Date.parse(a.eta) > Date.parse(b.eta) ? 1 : -1
      );
    }
  };

  const getOutOfStockText = () => {
    const quanityOnOrder = getQuantityOnOrder();
    if (
      quanityOnOrder !== null &&
      quanityOnOrder !== undefined &&
      quanityOnOrder.length > 0
    ) {
      if (quanityOnOrder[0].quantity > 0) {
        const initialVal = quanityOnOrder[0].eta;
        const nearestTotalQtyOnOrder =
          quanityOnOrder !== null &&
          quanityOnOrder !== undefined &&
          quanityOnOrder?.reduce(
            (acc: any, cur: any) =>
              cur.eta === initialVal ? acc + cur.quantity : acc,
            0
          );

        return (
          <WarehouseETAExpectedShip
            date={
              quanityOnOrder[0].eta !== undefined &&
              quanityOnOrder[0].eta !== null &&
              quanityOnOrder[0].eta !== ''
                ? quanityOnOrder[0].eta
                : ''
            }
            etaEllipsis={etaEllipsis}
            quantity={nearestTotalQtyOnOrder}
            tooltipsShow={tooltipsShow}
          />
        );
      } else {
        const OutofstockText = `${translate('Common.Outofstock')}`;
        return OutofstockText;
      }
    } else {
      return (
        <div
          style={{
            maxWidth: etaEllipsis ? '65px' : 'auto',
            overflow: etaEllipsis ? 'hidden' : 'none',
            textOverflow: etaEllipsis ? 'ellipsis' : 'none',
            whiteSpace: etaEllipsis ? 'nowrap' : undefined,
          }}
        >
          {translate('Common.Outofstock')}
        </div>
      );
    }
  };

  return (
    <>
      <Typography
        color={centralStock === 0 && localStock === 0 ? '#B11616' : '#18846F'}
        component="span"
        data-testid={'WarehouseETAOutOfStock'}
        sx={{
          borderRadius: '16px',
          cursor:
            centralStock === 0 && localStock === 0 ? 'pointer' : 'initial',
          display: 'flex',
          fontFamily: 'Roboto',
          fontSize: '12px',
          fontStyle: 'normal',
          lineHeight: '16px',
        }}
        variant="body2"
      >
        <Stack alignItems="center" direction="row" justifyContent="center">
          <Box
            sx={{
              display: 'flex',
              marginRight: reserveFlag === true ? '0.50rem' : '0rem',
            }}
          >
            {preOrderEtaStockDetails !== undefined ? (
              <>
                <Typography
                  color={tooltipsShow ? 'black' : '#B11616'}
                  component="span"
                  sx={{
                    borderRadius: '16px',
                    cursor:
                      centralStock === 0 && localStock === 0
                        ? 'pointer'
                        : 'initial',
                    fontSize: '12px',
                    lineHeight: '16px',
                  }}
                  variant="body2"
                >
                  {getOutOfStockText()}
                </Typography>
              </>
            ) : (
              <div
                style={{
                  maxWidth: etaEllipsis ? '65px' : 'auto',
                  overflow: etaEllipsis ? 'hidden' : 'none',
                  textOverflow: etaEllipsis ? 'ellipsis' : 'none',
                  whiteSpace: etaEllipsis ? 'nowrap' : undefined,
                }}
              >
                {translate('Common.Outofstock')}
              </div>
            )}
          </Box>
        </Stack>
      </Typography>
    </>
  );
}
